import React, { useState, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import { MdLiveHelp } from "react-icons/md";
import HelpModal from "../../shared/HelpModal";
import HelpContext from "../../shared/context/HelpProvider";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";

const baseURL = process.env.REACT_APP_API_JOBS;

export default function Add({
  increment,
  counter,
  mekhraz,
  amotMedaCat,
  amotMeda,
}) {
  const { showHelp, setShowHelp, saeef, setSaeef } = useContext(HelpContext);
  const [error, setError] = useState(false);
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();
  //const [amotMedaCat, setAmotMedaCat] = useState([]);
  const [newAma, setNewAma] = useState({
    meshkal: null,
    tsion: null,
    amot_meda_cat: 1,
    mekhraz: mekhraz.id,
  });
  const totalMeshkal = amotMeda.reduce((a, b) => a + b.meshkal, 0);

  const handleChange = (e) => {
    e.preventDefault(); // prevent the default action
    const { name, value } = e.target;

    setNewAma((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleDDSChange = (e) => {
    e.preventDefault();
    const n = Number(e.target.value);
    const name = e.target.name;
    setNewAma((prevState) => ({
      ...prevState,
      [name]: n,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const searchAma = amotMeda.find(
      (ama) => ama.amot_meda_cat == newAma.amot_meda_cat
    );
    const max = "" + (100 - Number(totalMeshkal));
    if (searchAma) alert("אמת מידה זו הוגדרה כבר!!!");
    else if (Number(totalMeshkal) + Number(newAma.meshkal) > 100) {
      alert(
        "לא ניתן להוסיף אמת מידה זו כי סיכום השיקלול גדול ממאה!!! המשקל המקסימלי לא יכול לעלות על " +
          max
      );
    } else {
      let isMounted = true;
      const controller = new AbortController();
      const saveData = async () => {
        try {
          const response = await axiosPrivate.post(
            baseURL + "amotmeda/",
            newAma,
            {
              signal: controller.signal,
            }
          );
          isMounted && increment();
        } catch (err) {
          if (err.response) {
            alert(HandleHttpErrors(err.response.status));
            if (err.response.status === 401) {
              navigate("/login", { state: { from: location }, replace: true });
            } else if (err.response.status === 403) {
              alert(HandleHttpErrors(err.response.status));
            }
            console.log(err.response);
          } else if (err.request) {
            alert(
              " The client never received a response, and the request was never left"
            );
            console.log(err.request);
          } else {
            console.log(err);
            alert(" Anything else");
          }
        }
      };

      saveData();
      setError(false);
    }
  };
  // render

  return (
    <div>
      <HelpModal />
      <center>
        <div className="card text-dark bg-light container p-3  border">
          <div className="card-header">
            <h3
              onClick={() => {
                setSaeef("25-2");
                setShowHelp(true);
              }}
            >
              אמות המידה של המכרז: {mekhraz.title}
              <span className="help">
                <MdLiveHelp />
              </span>
            </h3>
          </div>
          <div className="card-body">
            <Row>
              <Col>
                <form onSubmit={handleSubmit} className="mbsc-form-group">
                  <div className="form-group">
                    <label htmlFor="amot_meda_cat">קטגוריה:</label>
                    <br />
                    <select
                      name="amot_meda_cat"
                      onChange={handleDDSChange}
                      value={newAma.amot_meda_cat}
                    >
                      {amotMedaCat?.map((a) => (
                        <option key={a.id} value={a.id}>
                          {a.title}
                        </option>
                      ))}
                    </select>
                  </div>
                  <br></br>
                  <div className="form-group">
                    <label htmlFor="meshkal">משקל ממאה נקודות</label>
                    <input
                      type="number"
                      name="meshkal"
                      value={newAma.meshkal}
                      onChange={handleChange}
                      className="form-control"
                      id="meshkal"
                      placeholder=""
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="tsion">ציון</label>
                    <input
                      type="number"
                      name="tsion"
                      value={newAma.tsion}
                      onChange={handleChange}
                      className="form-control"
                      id="tsion"
                      placeholder=""
                    />
                  </div>

                  <br />
                  <button type="submit" className="btn btn-primary">
                    אישור
                  </button>
                </form>
              </Col>
            </Row>
          </div>
        </div>
      </center>
    </div>
  );
}
